module.exports = __webpack_public_path__ + "img/apropos.4795d40e.jpg";